import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "./utils";
import type {
  ClauseTemplatesGetResponse,
  SectionTemplatesGetResponse,
  DocumentTemplatesGetResponse,
  DocumentTemplateStatesGetResponse,
} from "../../../api/src/admin/templates/route";
import type { QuestionnaireMapGetResponse } from "../../../api/src/admin/questionnaire-map/route";

export const templatesApi = createApi({
  reducerPath: "templatesApi",
  baseQuery,
  endpoints: (builder) => ({
    getClauseTemplates: builder.query<ClauseTemplatesGetResponse, void>({
      query: () => ({ url: `admin/templates/clause-templates`, method: "GET" }),
    }),
    getSectionTemplates: builder.query<SectionTemplatesGetResponse, void>({
      query: () => ({
        url: `admin/templates/section-templates`,
        method: "GET",
      }),
    }),
    getDocumentTemplates: builder.query<DocumentTemplatesGetResponse, void>({
      query: () => ({
        url: `admin/templates/document-templates`,
        method: "GET",
      }),
    }),
    getDocumentTemplateStates: builder.query<
      DocumentTemplateStatesGetResponse,
      string
    >({
      query: (documentTemplateId) => ({
        url: `admin/templates/document-template-states/${documentTemplateId}`,
        method: "GET",
      }),
    }),
    getQuestionnaireMap: builder.query<QuestionnaireMapGetResponse, string>({
      query: (documentTemplateId) => ({
        url: `admin/questionnaire-map?documentTemplateId=${documentTemplateId}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetClauseTemplatesQuery,
  useGetSectionTemplatesQuery,
  useGetDocumentTemplatesQuery,
  useGetDocumentTemplateStatesQuery,
  useGetQuestionnaireMapQuery,
} = templatesApi;
